const stubs = [
    {
        definition: {
            id: 'keychain',
            type: 'module',
            factory: () => ({}),
        },
    },
];
export default stubs;
